import { createFileRoute } from '@tanstack/react-router'
import { EmailUnsubscribePage } from '../components/email-pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/abmelden')({
  head: () => noIndexRouteHead('emailUnsubscribe', 'de'),
  component: EmailUnsubscribePage,
})
